import React from 'react';




class Pagenotfound extends React.Component{
    render(){
        return( 
                <img src="/assets/images/pagenotfound.jpg" alt="page not found" width="100%"></img>

             )
}
}
export default Pagenotfound